import React from "react";

function VidScreen() {
  return <div>VidScreen</div>;
}

export default VidScreen;
